import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";
// or with custom SVG
export const MoreIcon = Styled(createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33333 6.66667C2.6 6.66667 2 7.26667 2 8C2 8.73333 2.6 9.33333 3.33333 9.33333C4.06667 9.33333 4.66667 8.73333 4.66667 8C4.66667 7.26667 4.06667 6.66667 3.33333 6.66667Z"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="white"
    />
    <path
      d="M12.6666 6.66667C11.9333 6.66667 11.3333 7.26667 11.3333 8C11.3333 8.73333 11.9333 9.33333 12.6666 9.33333C13.4 9.33333 14 8.73333 14 8C14 7.26667 13.4 6.66667 12.6666 6.66667Z"
      stroke="currentColor"
      fill="white"
      strokeWidth="1.2"
    />
    <path
      d="M8.00002 6.66667C7.26669 6.66667 6.66669 7.26667 6.66669 8C6.66669 8.73333 7.26669 9.33333 8.00002 9.33333C8.73335 9.33333 9.33335 8.73333 9.33335 8C9.33335 7.26667 8.73335 6.66667 8.00002 6.66667Z"
      stroke="currentColor"
      fill="white"
      strokeWidth="1.2"
    />
  </svg>,
  "More",
));

export default MoreIcon;
